<h1>Tab Menu</h1>
<toolbox-example-tab-menu *ngFor="let orientation of orientations; trackBy: trackByIndex" [orientation]="orientation"></toolbox-example-tab-menu>
<div class="clearfix"></div>